import { darken, lighten } from '@material-ui/core/styles'

const styles = theme => ({
  'tfa-card': { 
    animation: 'fadeUp 0.4s ease both' 
  },
  'digit-input': {
    width: '32px',
    height: '44px',
    border: '1.5px solid #c8c8c8',
    borderRadius: '12px',
    background: 'var(--color-background-secondary)',
    fontSize: '26px',
    fontWeight: '500',
    textAlign: 'center',
    color: 'var(--color-text-primary)',
    outline: 'none',
    transition: 'border-color 0.15s, box-shadow 0.15s, transform 0.1s',
    '&:focus': {
      borderColor: theme.palette.primary.main,
      boxShadow: '0 0 0 3px rgba(51,51,51,0.18)'
    },
    '&.filled': { 
      animation: 'pop 0.18s ease' 
    },
    '&.success-input': {
      borderColor: theme.palette.primary.main + ' !important',
      background: lighten(theme.palette.primary.main, 0.9) + ' !important',
      color: darken(theme.palette.primary.main, 0.8) + ' !important'
    },
    '&.error-input': {
      borderColor: theme.palette.error.light + ' !important',
      background: '#FCEBEB !important',
      color: darken(theme.palette.error.light, 0.8) + ' !important'
    }
  },
  'submit-btn': {
    width: '100%',
    padding: '14px',
    border: 'none',
    borderRadius: '12px',
    fontSize: '15px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'opacity 0.2s, transform 0.1s, background 0.2s',
    letterSpacing: '0.02em',
    '&:active': { 
      transform: 'scale(0.98)' 
    },
    '&:disabled': { 
      cursor: 'not-allowed' 
    }
  },
  'progress-bar': {
    position: 'absolute',
    bottom: '0; left: 0',
    height: '2px',
    background: theme.palette.primary.main,
    borderRadius: '0 0 16px 16px',
    transition: 'width 0.3s ease'
  }
})

export default styles
